import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Backdrop,
  CircularProgress,
  Alert,
  Autocomplete,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { categoryService } from "../services/categoryService";
import { useDispatch, useSelector } from "react-redux";
import { addCategory, deleteCategory } from "../redux/actions/categorysActions";
import { CategoryUpdate } from "./UI/reusable-components/CategoryComponents/CategoryUpdate";
import useAlert from "../hooks/useAlert";
import CategoryMatchingModal from "./UI/reusable-components/CategoryComponents/CategoryMatchingModal";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import { AiOutlinePartition } from "react-icons/ai";
import CategoryProductEdithModal from "./UI/reusable-components/CategoryComponents/CategoryProductEdithModal";
import { getMarketPlaces } from "../redux/actions/marketplacesActions";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import ecommercePlaceService from "../services/ecommercePlaceService";
import marketplacesService from "../services/marketplacesService";
import { unwrapThunkList } from "../utils/helpers";
const flattenCategories = (categories, prefix = "") => {
  return categories.reduce((acc, category) => {
    const categoryName = category.name;
    acc.push({
      id: category.id,
      name: categoryName,
      vatRate: category.vatRate,
      parentId: category.parent?.id,
    });
    if (category.inverseParent?.length > 0) {
      acc = acc.concat(flattenCategories(category.inverseParent, categoryName));
    }
    return acc;
  }, []);
};

export const Categorys = () => {
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [selectedKdv, setSelectedKdv] = useState(null);
  const [showSubCategories, setShowSubCategories] = useState({});
  const [searchTerm, setSearchTerm] = useState(null);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [openDeleteErrorModal, setOpenDeleteErrorModal] = useState(false);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
  const [selectedCategoryForEdit, setSelectedCategoryForEdit] = useState(null);
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setloading] = useState(false);
  const [openProductCategoryModal, setOpenProductCategoryModal] =
    useState(false);

  const [allPlaces, setAllPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState([]);

  const [importModalOpen, setImportModalOpen] = useState(false);
  const [selectedEcommerce, setSelectedEcommerce] = useState("");
  const [selectedVatRate, setSelectedVatRate] = useState("");
  const [importLoading, setImportLoading] = useState(false);
  const [importResultModal, setImportResultModal] = useState(false);
  const [importResult, setImportResult] = useState({
    success: false,
    message: "",
  });
  const ecommerceList = allPlaces.filter((p) => p.type === "ecommerce");
  const vatRates = [0, 1, 8, 10, 18, 20];

  const handleOpenProductCategoryModal = (category) => {
    setModalCategory(category);
    setOpenProductCategoryModal(true);
  };
  const handleCloseProductCategoryModal = () => {
    setModalCategory(null);
    setOpenProductCategoryModal(false);
  };

  const handleOpenModal = (category) => {
    setModalCategory(category);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setModalCategory(null);
    setOpenModal(false);
  };

  useEffect(() => {
    if (selectedCategoryForEdit) {
      setOpenDialogUpdate(true);
    }
  }, [selectedCategoryForEdit]);

  const handleEditCategory = (data) => {
    setSelectedCategoryForEdit(data);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const [marketResponse, ecommerceResponse] = await Promise.all([
          dispatch(getMarketPlaces()),
          ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
        ]);

        // E-ticaret platformlarını tekrarsız olarak al
        const ecommerceData = ecommerceResponse.data?.data?.data || [];
        const uniqueEcommercePlaces = Array.from(
          new Set(ecommerceData.map((item) => item.ecommercePlaceName))
        ).map((name) => {
          const firstItem = ecommerceData.find(
            (item) => item.ecommercePlaceName === name
          );
          return {
            id: firstItem.ecommercePlaceId,
            name: name,
            type: "ecommerce",
          };
        });

        const marketList = unwrapThunkList(marketResponse);
        const combinedData = [
          ...marketList.map((item) => ({
            ...item,
            type: "marketplace",
          })),
          ...uniqueEcommercePlaces,
        ];

        setAllPlaces(combinedData);
      } catch (err) {
        console.error("Platform fetch error:", err);
      }
    };
    fetchPlatforms();
  }, [dispatch]);
  const fetchCategories = async (pageNumber = 1) => {
    try {
      const placeId = {
        marketPlaceId:
          selectedPlace?.type == "marketplace" ? selectedPlace?.id : 0,
        ecommercePlaceId:
          selectedPlace?.type != "marketplace" ? selectedPlace?.id : 0,
      };
      setloading(true);
      const response = await categoryService.getCategoriesApi(
        token,
        pageNumber,
        searchTerm,
        authUserId,
        placeId
      );
      const fetchedCategories = response.data?.data?.data;
      setTotalCount(response.data?.data?.recordsTotal);

      const categoriesTree = buildCategoryTree(fetchedCategories);
      setCategories(categoriesTree);
      setFilteredCategories(categoriesTree);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.error("Kategoriler alınırken bir hata oluştu:", error);
    }
  };

  const buildCategoryTree = (categories) => {
    const processCategory = (category) => {
      return {
        ...category,
        subCategories: category.inverseParent?.map(processCategory) || [],
      };
    };

    return categories
      ?.map(processCategory)
      .filter((category) => !category.parent);
  };

  useEffect(() => {
    fetchCategories(page);
  }, [page]);

  const handleCategoryChange = (e) => {
    const selectedCategoryName = e.target.value;
    setSelectedCategoryName(selectedCategoryName);
    const selectedCategory = flattenedCategories.find(
      (category) => category.name === selectedCategoryName
    );
    setSelectedCategory(selectedCategory);
  };
  const { showSuccessAlertCategoryAdd, showErrorAlertCategoryAdd } = useAlert();
  const handleCreate = async () => {
    if (newCategory.trim() === "") {
      alert("Lütfen geçerli bir kategori girin.");
      return;
    }
    if (selectedKdv == null) {
      alert("Lütfen KDV oranı seçinn.");
      return;
    }

    const categoryData = {
      name: newCategory,
      vatRate: selectedKdv,
      userId: authUserId,
      createTime: new Date(),
      updateTime: new Date(),
      ia: true,
      parentId: selectedCategory?.id || null,
    };

    try {
      await dispatch(addCategory(categoryData, token));
      await fetchCategories();
      setNewCategory("");
      setSelectedKdv("");
      setSelectedCategoryName("");
      setSelectedCategory(null);
      showSuccessAlertCategoryAdd();
    } catch (error) {
      showErrorAlertCategoryAdd();
    }
  };

  const handleDeleteDialogOpen = (categoryId, isRootCategory) => {
    setCategoryToDelete({ id: categoryId, isRootCategory });
    setOpenDeleteDialog(true);
  };

  const handleUpdateDialogOpen = (categoryId) => {
    setCategoryToDelete({ categoryId });
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setCategoryToDelete(null);
  };

  const handleDelete = async () => {
    try {
      await dispatch(deleteCategory(categoryToDelete.id, token));
      await fetchCategories();
      setOpenDeleteDialog(false);
      setCategoryToDelete(null);
    } catch (error) {
      console.error("Kategori silinirken hata oluştu:", error);
      setOpenDeleteDialog(false);
      setOpenDeleteErrorModal(true);
    }
  };

  const toggleSubCategories = (categoryName) => {
    setShowSubCategories((prev) => ({
      ...prev,
      [categoryName]: !prev[categoryName],
    }));
  };

  const handleFilter = (e) => {
    // const searchValue = e.target.value.toLowerCase();
    // setSearchTerm(searchValue);
    fetchCategories(page);
    // if (!searchValue) {
    //   setFilteredCategories(categories);
    //   return;
    // }

    // const filterCategoryTree = (categories) => {
    //   return categories.reduce((acc, category) => {
    //     const matchesSearch = category.name.toLowerCase().includes(searchValue);
    //     const filteredSubCategories = category.subCategories ?
    //       filterCategoryTree(category.subCategories) : [];

    //     if (matchesSearch || filteredSubCategories.length > 0) {
    //       acc.push({
    //         ...category,
    //         subCategories: filteredSubCategories
    //       });
    //     }
    //     return acc;
    //   }, []);
    // };

    // const filtered = filterCategoryTree(categories);

    // setFilteredCategories(filtered);
  };

  const flattenedCategories = flattenCategories(categories);

  useEffect(() => {
    const pageSize = 10;
    setTotalPages(Math.ceil(totalCount / pageSize));
  }, [totalCount]);
  const renderCategories = (categories) => {
    return categories.map((category) => (
      <Box
        key={category.id}
        sx={{
          marginBottom: 1,
          padding: { xs: 0.5, sm: 1 },
          border: "1px solid #ddd",
          borderRadius: 2,
          backgroundColor: "#ffffff",
          boxShadow: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <IconButton
              onClick={() => toggleSubCategories(category.name)}
              sx={{ marginRight: 2 }}
              disabled={!category.subCategories?.length}
            >
              {category.subCategories?.length
                ? showSubCategories[category.name]
                  ? "↓"
                  : "→"
                : "-"}
            </IconButton>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              {category.name}{" "}
              {category.vatRate ? `(KDV: %${category.vatRate})` : ""}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: { xs: "center", sm: "flex-end" },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Button
              variant="outlined"
              onClick={() => handleOpenProductCategoryModal(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<AiOutlinePartition />}
            >
              Ürün Ata
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleOpenModal(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<SyncIcon />}
            >
              Eşleştir
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleEditCategory(category)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<EditIcon />}
            >
              Düzenle
            </Button>

            <Button
              variant="outlined"
              onClick={() => handleDeleteDialogOpen(category.id, true)}
              sx={{
                borderRadius: 2,
                border: "1px solid #1F1B45",
                color: "#1F1B45",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 12px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                minWidth: { xs: "120px", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#F3F3F3",
                  border: "1px solid #2C285A",
                  color: "#2C285A",
                },
              }}
              startIcon={<DeleteIcon />}
            >
              Sil
            </Button>
          </Box>
        </Box>
        {showSubCategories[category.name] &&
          category.subCategories?.length > 0 && (
            <Box sx={{ marginTop: 2, marginLeft: { xs: 1, sm: 3 } }}>
              {renderCategories(category.subCategories)}
            </Box>
          )}
      </Box>
    ));
  };

  // İmport API çağrısı
  const handleImport = async () => {
    if (!selectedEcommerce || !selectedVatRate) {
      setImportResult({
        success: false,
        message: "Lütfen tüm alanları doldurun.",
      });
      setImportResultModal(true);
      return;
    }
    setImportLoading(true);
    try {
      // E-ticaret ve marketplace ayarlarını al
      const [ecommerceResponse, marketPlaceResponse] = await Promise.all([
        ecommercePlaceService.getEcommercePlaceAccountsApi(authUserId, token),
        marketplacesService.getMarketPlacesAccountsApi(authUserId, token),
      ]);

      // Seçilen e-ticaret platformunun adını bul
      const selectedEcommerceData = ecommerceResponse.data?.data?.data?.find(
        (item) => item.ecommercePlaceId === selectedEcommerce
      );
      const ecommerceName = selectedEcommerceData?.ecommercePlaceName;

      // Marketplace ayarlarını formatla
      const marketPlaceSettings = Array.isArray(marketPlaceResponse?.data?.data)
        ? marketPlaceResponse.data.data
        : marketPlaceResponse?.data?.data?.data || [];

      const formattedMarketPlaceSettings = marketPlaceSettings.map(
        (setting) => ({
          id: setting?.id || 0,
          userId: setting?.userId || authUserId,
          marketPlaceId: setting?.marketPlaceId || 0,
          marketPlaceName: setting?.marketPlaceName || "",
          valueId: setting?.valueId || "",
          value: setting?.value || "",
          createDate: setting?.createDate || new Date().toISOString(),
          updateDate: setting?.updateDate || new Date().toISOString(),
          ia: true,
        })
      );

      // Tüm e-ticaret platform ayarlarını al
      const ecommerceSettings = ecommerceResponse.data?.data?.data?.map(
        (setting) => ({
          id: setting.id,
          userId: setting.userId,
          ecommercePlaceId: setting.ecommercePlaceId,
          ecommercePlaceName: setting.ecommercePlaceName,
          value: setting.value,
          valueId: setting.valueId,
          createDate: setting.createDate,
          updateDate: setting.updateDate,
          ia: true,
        })
      );

      const body = {
        marketPlaceSetting: formattedMarketPlaceSettings,
        ecommercePlaceSettings: ecommerceSettings,
        vatRate: Number(selectedVatRate),
      };

      console.log(
        "Import API isteği gönderiliyor. Body:",
        JSON.stringify(body, null, 2)
      );

      const importResponse = await axios.post(
        `https://v2api.pazaryericonverter.com/Workload/Category/${ecommerceName}/ImportCategory`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setImportResult({
        success: true,
        message: "Kategori aktarımı başarıyla başlatıldı!",
      });
      setImportResultModal(true);
      setImportModalOpen(false);
      setSelectedEcommerce("");
      setSelectedVatRate("");
    } catch (err) {
      console.error("Import error detayları:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        headers: err.response?.headers,
        config: err.config,
      });
      setImportResult({
        success: false,
        message: "Aktarım sırasında hata oluştu!",
      });
      setImportResultModal(true);
    }
    setImportLoading(false);
  };

  // İmport modalı açıldığında allPlaces'i logla
  useEffect(() => {
    if (importModalOpen) {
      console.log("allPlaces:", allPlaces);
    }
  }, [importModalOpen, allPlaces]);

  return (
    <Box sx={{ width: "100%", padding: { xs: 0.5, sm: 1 } }}>
      <Box
        sx={{
          padding: { xs: 2, sm: 3 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          mt: { xs: 2, sm: 4 },
          mb: { xs: 2, sm: 3 },
          ml: { xs: 0, sm: 1 },
          backgroundColor: "#F7F9FC",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          gap: { xs: 2, sm: 0 },
        }}
      >
        {/* Başlık */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ width: 4, height: 24, backgroundColor: "#1F1B45", mr: 1 }}
          />
          <Typography
            variant="h6"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontWeight: "bold",
              color: "#333",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Kategori Ağacı
          </Typography>
        </Box>
        {/* İçeri Aktar butonu ve açıklama */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontStyle: "italic",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            E-ticaret sitelerinden kategorilerinizi kolayca içeri
            aktarabilirsiniz
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth={false}
            sx={{ width: { xs: "100%", sm: "auto" } }}
            onClick={() => setImportModalOpen(true)}
          >
            İçeri Aktar
          </Button>
        </Box>
      </Box>
      <Divider sx={{ marginBottom: 1 }} />
      {/* Kategori Ekleme Formu */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 5 },
          borderRadius: 2,
          boxShadow: 2,
          marginBottom: 3,
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
          }}
        >
          <Autocomplete
            size="small"
            sx={{ flex: { xs: "none", sm: 4 } }}
            options={[
              { id: null, name: "Ana Kategori Olarak Ekle" },
              ...flattenedCategories,
            ]}
            getOptionLabel={(option) => option?.name ?? ""}
            isOptionEqualToValue={(option, value) =>
              (option?.id ?? null) === (value?.id ?? null)
            }
            value={
              selectedCategory ?? { id: null, name: "Ana Kategori Olarak Ekle" }
            }
            onChange={(_, newValue) => {
              const cat = newValue?.id != null ? newValue : null;
              setSelectedCategory(cat);
              setSelectedCategoryName(cat ? cat.name : "");
            }}
            renderInput={(params) => (
              <TextField {...params} label="Üst Kategori" placeholder="Kategori ara..." />
            )}
          />
          <TextField
            size="small"
            label="Eklenecek Kategori"
            variant="outlined"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            sx={{ flex: { xs: "none", sm: 2 } }}
          />
          <FormControl sx={{ flex: { xs: "none", sm: 1 } }} size="small">
            <InputLabel>KDV Oranı</InputLabel>
            <Select
              value={selectedKdv}
              onChange={(e) => setSelectedKdv(e.target.value)}
              label="KDV Oranı"
            >
              <MenuItem value={0}>%0</MenuItem>
              <MenuItem value={1}>%1</MenuItem>
              <MenuItem value={8}>%8</MenuItem>
              <MenuItem value={10}>%10</MenuItem>
              <MenuItem value={18}>%18</MenuItem>
              <MenuItem value={20}>%20</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            onClick={handleCreate}
            sx={{
              borderRadius: 18,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              height: "100%",
              flex: { xs: "none", sm: 1 },
              boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
              "&:hover": {
                backgroundColor: "#2C285A",
                boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              },
            }}
          >
            Kategori Ekle
          </Button>
        </Box>
      </Box>

      {/* Kategori Arama Formu */}
      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: 2, sm: 3 },
          borderRadius: 2,
          boxShadow: 2,
          marginBottom: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <TextField
            size="small"
            label="Kategori Ara"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Kategori ara"
          />
          <TextField
            select
            size="small"
            label="Eşleşme Yapılmayan Pazaryeri"
            variant="outlined"
            value={selectedPlace}
            onChange={(e) => setSelectedPlace(e.target.value)}
            sx={{
              minWidth: { xs: "100%", sm: 200 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <MenuItem value={null}>Seç</MenuItem>
            {allPlaces.map((place) => (
              <MenuItem key={place.id} value={place}>
                {place.name}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="contained"
            onClick={handleFilter}
            sx={{
              borderRadius: 2,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Ara
          </Button>
        </Box>
      </Box>

      {/* Kategori Listeleme */}
      {renderCategories(filteredCategories)}

      <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Bu kategoriyi silmek, tüm alt kategorileri ve bağlantılı ürünleri de
            silecektir. Silmek istediğinizden emin misiniz ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            İptal
          </Button>
          <Button onClick={handleDelete} color="error">
            Evet, Sil
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteErrorModal}
        onClose={() => setOpenDeleteErrorModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 0 }}>Kategori Silinemiyor</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{
              "& .MuiAlert-message": { width: "100%" },
            }}
          >
            İlgili kategoriye bağlı alt kategori veya ürün bulunmaktadır. Öncesinde
            bunların silinmesi veya taşınması gerekmektedir.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ pt: 2, px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpenDeleteErrorModal(false)}
            variant="contained"
            color="primary"
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <CategoryUpdate
        openDialog={openDialogUpdate}
        handleCloseDialog={() => setOpenDialogUpdate(false)}
        data={selectedCategoryForEdit}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          marginTop: 2,
        }}
      >
        <Button
          variant="outlined"
          disabled={page === 1}
          onClick={() => setPage((prev) => prev - 1)}
        >
          Geri
        </Button>

        {/* Current Page / Total Pages */}
        <Typography variant="body1" component="span">
          Sayfa {page} / {totalPages}
        </Typography>

        <Button
          variant="contained"
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => prev + 1)}
        >
          İleri
        </Button>
      </Box>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog
        open={importResultModal}
        onClose={() => setImportResultModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { minWidth: 400 } }}
      >
        <DialogTitle>{importResult.success ? "Başarılı" : "Hata"}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{importResult.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setImportResultModal(false)}
            variant="contained"
            color={importResult.success ? "success" : "error"}
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      {/* Import Modal */}
      <Dialog
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: { xs: "95%", sm: "auto" },
            margin: { xs: 1, sm: "auto" },
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            fontSize: { xs: "1.1rem", sm: "1.25rem" },
          }}
        >
          Kategori İçeri Aktarma
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>E-ticaret Platformu</InputLabel>
              <Select
                value={selectedEcommerce}
                onChange={(e) => setSelectedEcommerce(e.target.value)}
                label="E-ticaret Platformu"
              >
                {ecommerceList.map((place) => (
                  <MenuItem key={place.id} value={place.id}>
                    {place.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>KDV Oranı</InputLabel>
              <Select
                value={selectedVatRate}
                onChange={(e) => setSelectedVatRate(e.target.value)}
                label="KDV Oranı"
              >
                {vatRates.map((rate) => (
                  <MenuItem key={rate} value={rate}>
                    %{rate}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            p: 2,
            justifyContent: "space-between",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Button
            onClick={() => setImportModalOpen(false)}
            variant="outlined"
            fullWidth={false}
            sx={{
              borderRadius: 2,
              borderColor: "#1F1B45",
              color: "#1F1B45",
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                borderColor: "#2C285A",
                backgroundColor: "#F3F3F3",
              },
            }}
          >
            İptal
          </Button>
          <Button
            onClick={handleImport}
            variant="contained"
            disabled={importLoading}
            fullWidth={false}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            {importLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "İçeri Aktar"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <CategoryProductEdithModal
        open={openProductCategoryModal}
        handleClose={handleCloseProductCategoryModal}
        category={modalCategory}
      />
      {/* Modal Bileşeni */}
      <CategoryMatchingModal
        open={openModal}
        handleClose={handleCloseModal}
        category={modalCategory}
      />
    </Box>
  );
};
